import { useNavigate, useParams, useSearchParams } from "react-router";
import { bemCN } from "../../config/bem-classname";
import { Button, ButtonColors, ButtonSizes } from "../../ui/button/button";
import "./step-page.scss";
import { links } from "../../config/links";
import { Menu } from "../../components/menu/menu";
import { useEffect, useState } from "react";
import { ChoiceDto, StepDTO, StoryDTO } from "../../api/Api";
import { storyService } from "../../services/story-service";
import { ReactComponent as PauseIcon } from "../../shared/images/svg/pause.svg";
import { ReactComponent as MegaphoneIcon } from "../../shared/images/svg/megaphone.svg";

const stepPageCn = bemCN("step-page");

export const StepPage = () => {
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isVoiceStory, setisVoiceStory] = useState(
    searchParams.get("isVoice") === "true" ? true : false
  );

  const [colorsSteps, setColorsSteps] = useState<ButtonColors[]>([]);

  const navigate = useNavigate();
  const [step, setStep] = useState<StepDTO>();
  const [audio, setAudio] = useState<HTMLAudioElement>();

  const getStep = () => {
    storyService.getStep(Number(id)).then((s: StepDTO) => {
      setStep(s);
      setColorsSteps([...shuffle(colors)]);
    });
  };

  const colors = [
    ButtonColors.green,
    ButtonColors.orange,
    ButtonColors.violet,
    ButtonColors.blue,
    ButtonColors.red,
  ];

  function shuffle(arr: any[]) {
    let newArr = [...arr];
    let i = newArr.length - 1;
    for (i; i > 0; i--) {
      let j = Math.floor(Math.random() * (i + 1));
      [newArr[i], newArr[j]] = [newArr[j], newArr[i]];
    }
    return newArr;
  }

  const toFirstStep = () => {
    storyService.getStory(step?.storyId || -1).then((res: StoryDTO) => {
      let idFirstStep: number = res.firstStepId || -1;
      navigate(links.step + "/" + idFirstStep);
    });
  };

  useEffect(() => {
    getStep();
    stopVoice();
  }, [id]);

  useEffect(() => {
    if (!step?.audioUrl) {
      let textAudio = document.getElementById("story_text") as HTMLAudioElement;
      if (textAudio) {
        textAudio.src = "";
      }
    }
  }, [step]);

  const stopVoice = () => {
    setActiveIndexBtn(-1);
    audio?.pause();
    setAudio(undefined);
    setAudio(new Audio());
  };

  useEffect(() => {
    if (!isVoiceStory) stopVoice();
  }, [isVoiceStory]);

  useEffect(() => {
    setAudio(new Audio());
    return () => {
      audio?.pause();
      setAudio(undefined);
    };
  }, [1]);

  useEffect(() => {
    let value = searchParams.get("isVoice");
    if (value?.toString() === "true") {
      setisVoiceStory(true);
    } else {
      setisVoiceStory(false);
    }
  }, [1]);

  const [activeIndexBtn, setActiveIndexBtn] = useState(-1);
  const playAudioStep = (index: number) => {
    let currentBtn: ChoiceDto | undefined = step?.choicesList
      ? step.choicesList[index]
      : undefined;
    if (currentBtn && audio) {
      if (currentBtn.choiceAudioUrl) {
        setActiveIndexBtn(index);
        audio.src = currentBtn.choiceAudioUrl;
        audio.play();
        audio.onended = (e: any) => {
          playAudioStep(index + 1);
        };
      }
    } else {
      setActiveIndexBtn(-1);
    }
  };

  return (
    <div className={stepPageCn()}>
      <Menu title={step?.storyName || "Сказка"} />
      {isVoiceStory && (
        <audio
          id="story_text"
          onEnded={() => playAudioStep(0)}
          autoPlay
          src={step?.audioUrl}
        ></audio>
      )}
      <div className={stepPageCn("content")}>
        {step && step.illustrationUrl && (
          <div>
            <img src={step?.illustrationUrl} />
            <Button
              size={ButtonSizes.small}
              color={ButtonColors.orange}
              icon={isVoiceStory ? <PauseIcon /> : <MegaphoneIcon />}
              onClick={() => setisVoiceStory(!isVoiceStory)}
            />
          </div>
        )}
        <p
          className={stepPageCn("text", {
            isBold: step && step.choicesList && step.choicesList.length == 0,
          })}
        >
          {step?.stepText}
        </p>

        <div className={stepPageCn("choices")}>
          {step &&
            step.choicesList &&
            step.choicesList.map((item: ChoiceDto, index: number) => (
              <Button
                key={index}
                id={activeIndexBtn === index ? "wiggle" : undefined}
                onClick={() =>
                  navigate(
                    links.step +
                      "/" +
                      (item.nextStepId || -1) +
                      "?isVoice=" +
                      isVoiceStory.toString()
                  )
                }
                text={item.choiceText !== "-" ? item.choiceText : "Завершить"}
                color={colorsSteps[index]}
                size={ButtonSizes.big}
              />
            ))}
        </div>

        {step && step.choicesList && step.choicesList.length == 0 && (
          <div className={stepPageCn("choices")}>
            <Button
              onClick={() => navigate(links.stories)}
              text={"Прочитать другую историю"}
              color={ButtonColors.green}
              size={ButtonSizes.big}
            />
            <Button
              onClick={toFirstStep}
              text={"Начать с начала"}
              color={ButtonColors.violet}
              size={ButtonSizes.big}
            />
          </div>
        )}
      </div>
    </div>
  );
};
